/* eslint-disable @typescript-eslint/no-unused-vars */
import { ConceptoVerificacion } from "src/utils/aspirantes/verificaciones";
import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextInput from "src/components/input/TextInput";
import {
  opcionesSexo,
  opcionesTipoIdentificacionPersonaNatural,
} from "src/utils/constantes";
import {
  useObtenerDepartamentosQuery,
  useObtenerHorariosDisponibilidadQuery,
  useObtenerPerfilesQuery,
  useObtenerSedesQuery,
} from "src/redux/api/maestrosApi";
import {
  departamentosRespToOpcionSelect,
  horariosRespToOpcionSelect,
  perfilesRespToOpcionSelect,
  sedeRespToOpcionSelect,
} from "src/redux/api/types/maestros";
import CustomAutocomplete from "src/components/input/Autocomplete";
import { FieldArray } from "formik";
import ExperienciaItem from "src/pages/formulario-cv/experiencia-laboral/ItemExperienciaLaboral";
import FileInput from "src/components/input/FileInput";

export interface CampoProps {
  campo: ConceptoVerificacion;
  values: any;
  setFieldValue: any;
  aspiranteId: any;
}

const RenderizadorCampo = ({
  campo,
  values,
  setFieldValue,
  aspiranteId,
}: CampoProps) => {
  const { data: perfilesResp } = useObtenerPerfilesQuery(undefined, {
    skip: campo !== ConceptoVerificacion.PERFIL_ID,
  });
  const { data: departamentosResp } = useObtenerDepartamentosQuery();
  const { data: horariosResp } = useObtenerHorariosDisponibilidadQuery();
  const { data: sedesResp } = useObtenerSedesQuery();

  const [fileDocumentoIdentidadAdjuntoId, setFileDocumentoIdentidadAdjuntoId] =
    useState<File | null>(null);
  const [fileTarjetaProfesionalAdjuntoId, setFileTarjetaProfesionalAdjuntoId] =
    useState<File | null>(null);
  const [
    fileCertificadoContraloriaAdjuntoId,
    setFileCertificadoContraloriaAdjuntoId,
  ] = useState<File | null>(null);
  const [
    fileCertificadoProcuraduriaAdjuntoId,
    setFileCertificadoProcuraduriaAdjuntoId,
  ] = useState<File | null>(null);
  const [
    fileCertificadoPoliciaNacionalAdjuntoId,
    setFileCertificadoPoliciaNacionalAdjuntoId,
  ] = useState<File | null>(null);
  const [
    fileAntecedentesProfesionalAdjuntoId,
    setFileAntecedentesProfesionalAdjuntoId,
  ] = useState<File | null>(null);
  const [fileCertificadoRnmcAdjuntoId, setFileCertificadoRnmcAdjuntoId] =
    useState<File | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileHojaDeVidaAdjuntoId, setFileHojaDeVidaAdjuntoId] =
    useState<File | null>(null);

  useEffect(() => {}, []);

  switch (campo) {
    case ConceptoVerificacion.TIPO_IDENTIFICACION:
      return (
        <TextInput
          label="Tipo de identificación"
          name="tipoIdentificacion"
          type="select"
          opciones={opcionesTipoIdentificacionPersonaNatural}
          data-testid="select-id"
        />
      );
    case ConceptoVerificacion.IDENTIFICACION:
      return (
        <TextInput
          label="Número de identificación"
          name="identificacion"
          type="text"
        />
      );
    case ConceptoVerificacion.PRIMER_NOMBRE:
      return (
        <TextInput label="Primer nombre" name="primerNombre" type="text" />
      );
    case ConceptoVerificacion.SEGUNDO_NOMBRE:
      return (
        <TextInput label="Segundo nombre" name="segundoNombre" type="text" />
      );
    case ConceptoVerificacion.PRIMER_APELLIDO:
      return (
        <TextInput label="Primer apellido" name="primerApellido" type="text" />
      );
    case ConceptoVerificacion.SEGUNDO_APELLIDO:
      return (
        <TextInput
          label="Segundo apellido"
          name="segundoApellido"
          type="text"
        />
      );
    case ConceptoVerificacion.FECHA_NACIMIENTO:
      return (
        <TextInput
          label="Fecha de nacimiento"
          name="fechaNacimiento"
          InputLabelProps={{ shrink: true }}
          type="date"
        />
      );
    case ConceptoVerificacion.SEXO:
      return (
        <TextInput
          label="Sexo"
          name="sexo"
          type="select"
          opciones={opcionesSexo}
          data-testid="select-id"
        />
      );
    case ConceptoVerificacion.CORREO_ELECTRONICO:
      return (
        <TextInput
          label="Correo principal"
          name="correoElectronico"
          type="email"
          InputLabelProps={{ shrink: true }}
        />
      );
    case ConceptoVerificacion.NUMERO_CELULAR:
      return <TextInput label="Celular" name="numeroCelular" type="text" />;
    case ConceptoVerificacion.PERFIL_ID:
      return (
        <TextInput
          label="Perfil"
          name="perfilId"
          type="select"
          opciones={
            perfilesResp ? perfilesRespToOpcionSelect(perfilesResp) : []
          }
          data-testid="select-id"
        />
      );
    case ConceptoVerificacion.DEPARTAMENTO_RESIDENCIA:
      return (
        <CustomAutocomplete
          label="Departamento"
          name="departamentoResidenciaId"
          type="autocomplete"
          setValue={() => {}}
          opciones={
            departamentosResp
              ? departamentosRespToOpcionSelect(departamentosResp)
              : []
          }
        />
      );
    case ConceptoVerificacion.EXPERIENCIAS_LABORALES:
      return (
        <FieldArray name="experienciasLaborales">
          {({ push, remove }) => (
            <Box>
              {values.experienciasLaborales &&
                values.experienciasLaborales.map((_: any, index: any) => (
                  <ExperienciaItem
                    key={index}
                    index={index}
                    remove={remove}
                    setFieldValue={setFieldValue}
                    values={values}
                    aspiranteId={aspiranteId}
                  />
                ))}
              <Button
                variant="outlined"
                onClick={() =>
                  push({
                    tipo: "",
                    nombreEmpresaInstitucion: "",
                    fechaInicio: "",
                    fechaFin: "",
                    nombreJefeInmediato: "",
                    telefonoJefeInmediato: "",
                    soporteId: "",
                  })
                }
              >
                Agregar experiencia
              </Button>
            </Box>
          )}
        </FieldArray>
      );
    case ConceptoVerificacion.HORARIOS_DISPONIBLES:
      return (
        <TextInput
          label="Horarios disponible"
          name="horariosDisponibles"
          type="select"
          multiple
          opciones={
            horariosResp ? horariosRespToOpcionSelect(horariosResp) : []
          }
          data-testid="select-id"
        />
      );
    case ConceptoVerificacion.SEDES_DISPONIBLES:
      return (
        <TextInput
          label="Sedes disponibles"
          name="sedesDisponibles"
          type="select"
          multiple
          opciones={sedesResp ? sedeRespToOpcionSelect(sedesResp) : []}
        />
      );
    case ConceptoVerificacion.HOJA_DE_VIDA:
      return (
        <FileInput
          id="hojaDeVidaAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("hojaDeVidaAdjuntoId", value);
          }}
          value={values.hojaDeVidaAdjuntoId}
          selectedFile={fileHojaDeVidaAdjuntoId}
          setSelectedFile={setFileHojaDeVidaAdjuntoId}
          label="Hoja de vida"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.DOCUMENTO_IDENTIDAD_ADJUNTO:
      return (
        <FileInput
          id="documentoIdentidadAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("documentoIdentidadAdjuntoId", value);
          }}
          value={values.documentoIdentidadAdjuntoId}
          selectedFile={fileDocumentoIdentidadAdjuntoId}
          setSelectedFile={setFileDocumentoIdentidadAdjuntoId}
          label="Documento de identidad"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.TARJETA_PROFESIONAL_ADJUNTO:
      return (
        <FileInput
          id="tarjetaProfesionalAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("tarjetaProfesionalAdjuntoId", value);
          }}
          value={values.tarjetaProfesionalAdjuntoId}
          selectedFile={fileTarjetaProfesionalAdjuntoId}
          setSelectedFile={setFileTarjetaProfesionalAdjuntoId}
          label="Tarjeta profesional"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.CERTIFICADO_CONTRALORIA_ADJUNTO:
      return (
        <FileInput
          id="certificadoContraloriaAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("certificadoContraloriaAdjuntoId", value);
          }}
          value={values.certificadoContraloriaAdjuntoId}
          selectedFile={fileCertificadoContraloriaAdjuntoId}
          setSelectedFile={setFileCertificadoContraloriaAdjuntoId}
          label="Certificado contraloria"
          nameFecha="certificadoContraloriaAdjuntoFecha"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.CERTIFICADO_PROCURADURIA_ADJUNTO:
      return (
        <FileInput
          id="certificadoProcuraduriaAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("certificadoProcuraduriaAdjuntoId", value);
          }}
          value={values.certificadoProcuraduriaAdjuntoId}
          selectedFile={fileCertificadoProcuraduriaAdjuntoId}
          setSelectedFile={setFileCertificadoProcuraduriaAdjuntoId}
          label="Certificado procuraduria"
          nameFecha="certificadoProcuraduriaAdjuntoFecha"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.CERTIFICADO_POLICIA_NACIONAL_ADJUNTO:
      return (
        <FileInput
          id="certificadoPoliciaNacionalAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("certificadoPoliciaNacionalAdjuntoId", value);
          }}
          value={values.certificadoPoliciaNacionalAdjuntoId}
          selectedFile={fileCertificadoPoliciaNacionalAdjuntoId}
          setSelectedFile={setFileCertificadoPoliciaNacionalAdjuntoId}
          label="Certificado prolicia nacional"
          nameFecha="certificadoPoliciaNacionalAdjuntoFecha"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.CERTIFICADO_RNMC_ADJUNTO:
      return (
        <FileInput
          id="certificadoRnmcAdjuntoId"
          setValue={(value: any) => {
            setFieldValue("certificadoRnmcAdjuntoId", value);
          }}
          value={values.certificadoRnmcAdjuntoId}
          selectedFile={fileCertificadoRnmcAdjuntoId}
          setSelectedFile={setFileCertificadoRnmcAdjuntoId}
          label="Certificado del registro nacional de medidas correctivas"
          nameFecha="certificadoRnmcAdjuntoFecha"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.CERTIFICADO_ANTECEDENTES_DISCIPLINARIOS_ADJUNTO:
      return (
        <FileInput
          id="certificadoAntecedentesDisciplinariosId"
          setValue={(value: any) => {
            setFieldValue("certificadoAntecedentesDisciplinariosId", value);
          }}
          value={values.certificadoAntecedentesDisciplinariosId}
          selectedFile={fileAntecedentesProfesionalAdjuntoId}
          setSelectedFile={setFileAntecedentesProfesionalAdjuntoId}
          label="Certificado antecedentes profesionales"
          nameFecha="certificadoAntecedentesDisciplinariosFecha"
          proyectoId=""
          aspiranteId={aspiranteId}
        />
      );
    case ConceptoVerificacion.FECHA_EXPEDICION_TARJETA_PROFESIONAL:
      return (
        <TextInput
          label="Fecha expedición tarjeta profesional"
          name="fechaExpedicionTarjetaProfesional"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
      );
    case ConceptoVerificacion.FORMACIONES_ACADEMICA:
      return (
        <>
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <TextInput
              label="Titulo obtenido"
              name="formacionesAcademicas[0].nombreTituloObtenido"
              type="text"
              InputLabelProps={{ shrink: true }}
            />
            <TextInput
              label="Institución"
              name="formacionesAcademicas[0].nombreInstitucion"
              type="text"
            />
            <TextInput
              label="Fecha de graduación"
              name="formacionesAcademicas[0].fechaGraduacion"
              type="date"
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          <FileInput
            id="formacionesAcademicas[0].soporteId"
            setValue={(value: any) => {
              setFieldValue("formacionesAcademicas[0].soporteId", value);
            }}
            value={values.formacionesAcademicas[0].soporteId}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            label="Acta de grado o diploma"
            proyectoId=""
            aspiranteId={aspiranteId}
            indications="Adjunte un certificado vigente, emitido en los últimos 30 días."
          />
        </>
      );
    default:
      return <Box>No soportado</Box>;
  }
};

export default RenderizadorCampo;
